import { ReactComponent } from './handshake-xl.svg';
export const HandshakeIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=handshake-xl.js.map